export enum AderentiAEnum {
    confcooperative = 'CONFCOOPERATIVE',
}
